import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar.js";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable.jsx";
import { Box, Grid, Typography, Button, Paper, TextField } from "@mui/material";
import useErrorHandler from "../../hooks/useErrorHandler.js";
import { useParams } from "react-router-dom";
import {
  getLists,
  getListsDownloadExport,
  getViewListsDownload,
} from "../../api/reports.js";
import { AttachmentsListsTable } from "../../config/grid-column-defs.js";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadDialog from "../../components/DownloadDialogComp.jsx";

export default function AttachmentsLists() {
  const [pageName, setPageName] = useState("Journal");
  const [sectionName, setSectionName] = useState("lines");
  const dispatch = useDispatch();
  const errorHandler = useErrorHandler();
  const [anchorEl, setAnchorEl] = useState(null);
  const open1 = Boolean(anchorEl);
  const snackbar = useSnackbar();
  const params = useParams();
  const { data: user } = useSelector((state) => state.user);
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const [pageNameListData, setPageNameDataList] = useState([]);
  const [sectionNameListData, setsectionNameDataList] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const dialogAction = useSelector((state) => state.dialog);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const [nameSearchInputValue, setNameSearchValue] = useState("");

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }
  let obj = AttachmentsListsTable.find((o) => o.headerName === "DOWNLOAD");
  addAdditionalColumnDownload(obj, dispatch);

  const getDownloadDocumentById = (reportName) => {
    setPercentComplete(0);

    const options = {
      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getViewListsDownload(
      {
        list_name: reportName,
        file: "xlsx",
      },
      options
    )
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${reportName}`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
        setDownloadInProgress(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DOWNLOADVIEW":
        dispatch({ type: "" });
        setDialogOpen(true);
        getDownloadDocumentById(dialogAction?.data.table_name);
        break;

      default:
        break;
    }
  }, [dialogAction]);
  //get table data//
  async function getReportsListData(limit,offset) {
    try {
      const { data } = await getLists(user?.token, {
        limit,
        offset,
        type:"listwithattachment",
        list_name:nameSearchInputValue,
      });
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  // async function getPageNameList() {
  //   try {
  //     const { data } = await getPageNameData(user.token, {});
  //     setPageNameDataList(data.data.pageList);
  //   } catch (error) {
  //     errorHandler(error);
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  // async function getSectionNameList() {
  //   try {
  //     const { data } = await getSectionNameData(user.token, {});
  //     setsectionNameDataList(data.data.sectionList);
  //   } catch (error) {
  //     errorHandler(error);
  //   } finally {
  //     // setLoading(false)
  //   }
  // }
  // useEffect(() => {
  //   getPageNameList();
  //   getSectionNameList();
  // }, []);
  // useEffect(() => {
  //   getSectionNameList();
  // }, [pageName]);
  useEffect(() => {
    refreshTable();
  }, [pageName, sectionName]);

  const onNameInputSearch = (event) => {
    setNameSearchValue(event.target.value);
    refreshTable();
  };
  const handleReset = (e) => {
    setNameSearchValue("");
    refreshTable();
  };
  return (
     <Box className="viewBox">
            <Box className="viewDetilsBox">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
        Transaction With  Attachments 
        </Typography>
        {/* <Button
          className="backBtn"
          onClick={() => {
            window.location.reload(); // Perform hard refresh after API call
          }}
        >
          Get latest column names
        </Button> */}
      </Box>

      <Box className="filter-box">
        <Grid container>
          <Grid item md={3} sm={4} xs={10}>
            <TextField
              autoComplete="off"
              placeholder={"Search List Name"}
              size="small"
              label=""
              name={"name"}
              variant="outlined"
              value={nameSearchInputValue}
              onChange={onNameInputSearch}
              fullWidth
            />
          </Grid>
          {nameSearchInputValue && (
            <Grid item md={2} sm={2} xs={2} style={{ margin: "0px 10px" }}>
              <Button
                size="small"
                type="button"
                style={{ color: "black", marginTop: "4px" }}
                onClick={(e) => handleReset(e)}
              >
                Reset
              </Button>
            </Grid>
          )}
        </Grid>
      </Box>
      <br />
      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={getReportsListData}
          columns={AttachmentsListsTable}
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </Paper>
      <DownloadDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        downloadInProgress={downloadInProgress}
        percentComplete={percentComplete}
      />
    </Box></Box>
  );
}
function addAdditionalColumnDownload(obj, dispatch) {
  if (obj === undefined) {
    AttachmentsListsTable.unshift({
      headerName: "DOWNLOAD",
      field: "actions",
      maxWidth: 100,
      cellClass: "downloadCenter",
      cellRendererFramework: (params) => (
        <Box>
          <Button
            title="Export CSV"
            className="actionIcon"
            onClick={() => {
              dispatch({ type: "DOWNLOADVIEW", data: params.data });
            }}
          >
            <DownloadIcon />
          </Button>
        </Box>
      ),
    });
  }
}
